
export enum AssignmentType {
	Unassigned = 1,
	AssignedToYou = 2,
	NotAssignedToYou = 3,
  }
  